import {AfterViewInit, Component, HostBinding, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {HmPromoComponent} from '../hm-promo/hm-promo.component';
import {HmSupportComponent} from '../hm-support/hm-support.component';
import {DigoService} from '../../../services/digo.service';
import {HmGpvComponent} from '../hm-gpv/hm-gpv.component';
import * as moment from 'moment/moment';
import {HmManualsComponent} from '../hm-manuals/hm-manuals.component';
import {HomeService, INavigateFromOperation} from '../../services/home.service';
import {HmRateService} from '../../services/hm-rate.service';
import {MatTabGroup} from '@angular/material/tabs';
import {environment} from '../../../../environments/environment';
import {Subject, Subscription} from 'rxjs';
import {ChatService} from 'src/app/home/services/chat.service';
import {ChatSoporteService} from 'src/app/home/services/chat-soporte.service';
import {SimyoService} from 'src/app/simyo/services/simyo.service';
import {allLocalStorage, PDV_MULTIMARCA, pdvAreas, tabHome} from 'src/app/shared/constantes';
import {allPermissions} from 'src/app/shared/permissions';
import {PermissionService} from 'src/app/shared/services/permission.service';
import {masterAllResponseSimyo} from 'src/app/simyo/models/masterAllSimyo';
import {Ipdv} from 'src/app/shared/models/pdvResponse';
import {HttpErrorResponse} from '@angular/common/http';
import {AcceptedPointsProgramComponent} from '../hm-points/modals/accepted-points-program/accepted-points-program.component';
import {HomePointsComponent} from '../hm-points/home-points/home-points.component';
import {PointsService} from '../../services/points.service';
import {take} from 'rxjs/operators';
import { TracerService } from 'src/app/services/tracer.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: [
        './home.component.css',
        '../../../../assets/css/home-theme.css',
    ],
    standalone: false
})
export class HomeComponent implements OnInit, AfterViewInit, OnDestroy {
    @HostBinding('@.disabled') disabled = true;
    @ViewChild('tabGroup') tabGroup: MatTabGroup;
    @ViewChild('tabPoints') tabPoints: HomePointsComponent;

    public version: string;
    public lastAccess: string;
    public pdv: Ipdv;
    public changeTab: Subject<any> = new Subject<any>();
    public allPermissions = allPermissions;
    public PDV_MULTIMARCA = PDV_MULTIMARCA;
    public notFinishDate = moment('2021-09-11');
    public today = moment();
    public clicoError: string = '';
    public clicoLoading: boolean = false;
    public superventasError: string = '';
    public superventasLoading: boolean = false;
    public tabHome = tabHome;
    private allSubscription: Subscription[] = [];
    public selectedIndexTab = 0;

    public showRedeemPoints = false;
    public rewardSelected = null;
    public amountSelected = null;
    public availablePoints = null;
    public currentSelectedIndex = 0;
    public showContentPoints = 'points';
    public dataPoints = null;
    public resumeData: any;
    public unreadChatCount = 0;
    public chatIsAvailable = false;
    public chatIsOpen = false;
    public chatIsMinimized = false;
    public unreadChatSoporteCount = 0;
    public chatSoporteIsAvailable = false;
    public chatSoporteIsOpen = false;
    public chatSoporteIsMinimized = false;

    public showMessageToast = false;
    private toastTimer?: any;

    constructor(
        private digoService: DigoService,
        private homeService: HomeService,
        private rateService: HmRateService,
        private dialog: MatDialog,
        private simyoService: SimyoService,
        public permSv: PermissionService,
        private pointsService: PointsService,
        private chatService: ChatService,
        public tracerService: TracerService,
        private chatSoporteService: ChatSoporteService
    ) {
        this.version = environment.version;
    }

    ngOnInit(): void {
        this.allSubscription.push(
            this.digoService.getPDV().subscribe((data: Ipdv) => {
                if (data) {
                    this.pdv = data;
                    this.refreshChatAvailable();
                    this.refreshChatSoporteAvailable();
                    this.setLastAccess();
                }
            })
        );

        this.simyoService
            .getMasterAllFromService()
            .subscribe((data: masterAllResponseSimyo) => {
                if (data && data.msg) {
                    this.simyoService.setMasterAll(data.msg);
                }
            });

        this.chatService.openChat$.subscribe({
            next: (isOpen: boolean) => this.chatIsOpen = isOpen
        });
        this.chatService.minimizedChat$.subscribe({
            next: (isMinimized: boolean) => this.chatIsMinimized = isMinimized
        });
        this.chatSoporteService.openChat$.subscribe({
            next: (isOpen: boolean) => this.chatSoporteIsOpen = isOpen
        });
        this.chatSoporteService.minimizedChat$.subscribe({
            next: (isMinimized: boolean) => this.chatSoporteIsMinimized = isMinimized
        });
        this.allSubscription.push(
            this.chatService.chatArchived$.subscribe(() => {
                this.refreshChatAvailable();
            })
        );
        this.allSubscription.push(
            this.chatSoporteService.chatArchived$.subscribe(() => {
                this.refreshChatSoporteAvailable();
            })
        );
    }

    ngAfterViewInit() {
        this.allSubscription.push(
            this.homeService.getViewBrandRates().subscribe((data: any) => {
                if (data != null) {
                    setTimeout(() => {
                        this.tabGroup.selectedIndex =
                            this.homeService.findIndexToMove(
                                this.tabGroup,
                                tabHome.TARIFAS
                            );
                        this.rateService.setFilterRatesByBrand(data);
                        this.homeService.setViewBrandRates(null);
                    });
                }
            })
        );

        this.allSubscription.push(
            this.homeService
                .getNavigateFromOperation()
                .subscribe((data: INavigateFromOperation) => {
                    if (data) {
                        this.tabGroup.selectedIndex =
                            this.homeService.findIndexToMove(
                                this.tabGroup,
                                tabHome.OPERACIONES
                            );
                    }
                })
        );

        this.allSubscription.push(
            this.homeService
                .getNavigateFromOperationPosVenta()
                .subscribe((data: INavigateFromOperation) => {
                    if (data) {
                        this.tabGroup.selectedIndex =
                            this.homeService.findIndexToMove(
                                this.tabGroup,
                                tabHome.OPERACIONES_POSVENTA
                            );
                    }
                })
        );

        this.allSubscription.push(
            this.homeService.getGoToTab().subscribe((data: any) => {
                if (data && data !== '') {
                    this.tabGroup.selectedIndex =
                        this.homeService.findIndexToMove(this.tabGroup, data);
                    this.homeService.setGoToTab('');
                }
            })
        );

        // Suscribirse al conteo de mensajes no leídos desde el servicio
        this.allSubscription.push(
            this.chatService.unreadCount$.subscribe(count => {
                this.unreadChatCount = count;
            }),
            this.chatSoporteService.unreadCount$.subscribe(count => {
                this.unreadChatSoporteCount = count;
            })
        );
    }

    ngOnDestroy() {
        if (this.allSubscription && this.allSubscription.length) {
            this.allSubscription.map((subs) => subs.unsubscribe());
        }
    }

    getPdv() {
        this.digoService.getPdvFromService().subscribe((data: Ipdv) => {
            this.digoService.setPDV(data);
        });
    }

    openPromoDialog() {
        const promoSaveDate = localStorage.getItem(
            allLocalStorage.promoSaveDate
        );
        const show =
            promoSaveDate == null || this.today.diff(promoSaveDate, 'days') > 0;

        localStorage.setItem(
            allLocalStorage.promoSaveDate,
            this.today.format('YYYY-MM-DD')
        );

        if (show) {
            this.dialog.open(HmPromoComponent, {
                backdropClass: 'md-backdrop',
                panelClass: 'md-container',
            });
        }
    }

    openGpvDialog() {
        this.dialog.open(HmGpvComponent, {
            backdropClass: 'md-backdrop',
            maxWidth: 500,
            panelClass: 'md-container-white',
            width: '100%',
            data: {
                pdv: this.pdv,
            },
        });
    }

    openSupportDialog() {
        this.dialog.open(HmSupportComponent, {
            backdropClass: 'md-backdrop',
            maxWidth: 800,
            minWidth: 500,
            maxHeight: '90vh',
            panelClass: 'md-container-white',
            data: {
                pdv: this.pdv,
            },
        });
    }

    openManualsDialog() {
        this.dialog.open(HmManualsComponent, {
            backdropClass: 'md-backdrop',
            maxWidth: 800,
            panelClass: 'md-container-white',
            width: '100%',
            data: {
                pdv: this.pdv,
            },
        });
    }

    setLastAccess() {
        if (
            this.pdv.info.last_access &&
            this.pdv.info.last_access !== '' &&
            this.pdv.info.last_access !== 'N/A'
        ) {
            this.lastAccess = moment(this.pdv.info.last_access).format(
                'DD/MM/YYYY HH:mm UTCZ'
            );
        }
    }

    public tabChanged(event) {
        this.doKeepAlive();
        if (event?.tab?.textLabel === tabHome.PUNTOS) {
            this.tabPoints.changeContent('points');
            if (this.pointsService.checkIsAcceptedPointsProgram(this.pdv.info.points_terms) === false) {
                this.askAcceptedPointsProgram(event);
                return;
            }
        }

        this.currentSelectedIndex = this.tabGroup.selectedIndex;
        this.changeTab.next(event);
    }

    doKeepAlive() {
        this.digoService.keepAlive().subscribe({
            next: (resp: any) => {
                if (!resp || resp !== 200) {
                    this.digoService.sendDataToLogs('log: Logout de usuario - Logout keepAlive, resp: ' + resp + ' - home.component - doKeepAlive');
                    this.digoService.goLogin();
                }
            },
            error: (error: HttpErrorResponse) => {
                this.digoService.sendDataToLogs('log: Logout de usuario - Logout keepAlive Error response: ' + error.message + ' - home.component - doKeepAlive');
                this.digoService.goLogin();
            },
        });
    }

    getUrlClico() {
        this.clicoError = '';
        this.clicoLoading = true;
        this.homeService.getUrlClicoFromService().subscribe(
            (data: any) => {
                if (data.result?.url) {
                    const url = data.result.url;
                    window.open(url, '_blank');
                }
                if (data.result?.error) {
                    this.clicoError = data.result?.error;
                }
                this.clicoLoading = false;
            },
            () => {
                this.clicoError =
                    'No se ha podido obtener el acceso a Clico. Pongase en contacto con su administrador';
                this.clicoLoading = false;
            }
        );
    }

    goToRedeemPoints(_rewardSelected) {
        this.showRedeemPoints = true;
        this.availablePoints = _rewardSelected.availablePoints;
        this.rewardSelected = _rewardSelected.reward;
        this.amountSelected = _rewardSelected.amount;
    }

    goBackHomePoints(event) {
        this.showRedeemPoints = false;
        this.showContentPoints = event;
    }

    updatePoints(event) {
        this.dataPoints = event;
    }

    updateResume(resume: any) {
        this.resumeData = resume;
    }

    private askAcceptedPointsProgram(event) {
        const dialogRef = this.dialog.open(
            AcceptedPointsProgramComponent,
            {
                backdropClass: 'md-backdrop',
                maxWidth: 800,
                panelClass: 'md-container-white',
                width: '100%',
            }
        );
        dialogRef.afterClosed().pipe(take(1)).subscribe((result) => {
            if (result == undefined) {
                // Cambiar al tab "Contrataciones"
                const hiringTabIndex = this.homeService.findIndexToMove(this.tabGroup, tabHome.CONTRATACIONES);
                this.tabGroup.selectedIndex = hiringTabIndex;
                return;
            }
            if (result === false) {
                this.tabGroup.selectedIndex = this.currentSelectedIndex;
                return;
            }
            this.digoService
                .putTermsInfo({
                    points_terms: JSON.stringify(result),
                    id_pdv: this.pdv.info.idpdv,
                    key: environment.digoApiKey,
                })
                .subscribe(() => {
                    this.pdv.info.points_terms = JSON.stringify(result);
                    this.currentSelectedIndex = this.tabGroup.selectedIndex;
                    this.changeTab.next(event);
                });
        });
    }

    openGlobalChat() {
        this.chatService.requestToggleChat();
    }

    openSupportChat() {
        this.chatSoporteService.requestToggleChat();
    }

    private refreshChatAvailable(): void {
        this.chatIsAvailable =
            this.permSv.hasPermFromV2(allPermissions.others.chat)
            && !this.chatService.isChatArchived;
    }

    private refreshChatSoporteAvailable(): void {
        // Entrada: solo permiso. En línea archivado: permiso ∧ !archived
        this.chatSoporteIsAvailable =
            this.permSv.hasPermFromV2(allPermissions.others.chat_soporte_pdv)
            && !this.chatSoporteService.isChatArchived;
    }

    goToCommercialPortalUrl(): void {
        window.open('https://mm-portalcomercial.grupomasmovil.com/', '_blank');
    }

    goToSuperventasUrl(){
        this.superventasError = '';
        this.superventasLoading = true;
            this.homeService.getUrlForSupervendedores().subscribe({
            next: (data: any) => {
                if (data.msg?.success == true) {
                    const url = data.msg.login_url;
                    if (url) {
                        window.open(url, '_blank');
                    } else {
                        this.superventasError = 'No se recibió una URL válida.';
                    }
                } else {
                    this.superventasError = data.msg.message || 'Error al obtener la URL.';
                }
            },
            error: (err) => {
                console.error('No se ha podido acceder a Supervendedores: ', err);
                this.superventasError = 'No se ha podido obtener el acceso a Supervendedores.';
                this.superventasLoading = false;
            },
            complete: () => {
                this.superventasLoading = false;
                if(this.superventasError != '') {
                    this.showToastTemporarily();
                }
            }
        });
    }

    public showToastTemporarily(): void {
        this.showMessageToast = true;
        if (this.toastTimer) {
            clearTimeout(this.toastTimer);
        }
        this.toastTimer = setTimeout(() => {
            this.showMessageToast = false;
        }, 30000);
    }

    public hideNewMessageToast(ev?: Event): void {
        if (ev) {
            ev.stopPropagation();
        }
        this.showMessageToast = false;
        if (this.toastTimer) {
            clearTimeout(this.toastTimer);
            this.toastTimer = undefined;
        }
    }
}
